<template>
  <NuxtImg
    ref="intersectionWrapperRef"
    v-bind="attrs"
    :src="computedSrc"
    :data-src="src"
  />
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false })

const attrs = useAttrs()

const headers = useRequestHeaders(['x-bot'])

const disableLazyLoading = headers['x-bot'] === 'true'

const { src, fallbackSrc = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='80' height='25'><defs><linearGradient id='g1'><stop stop-color='#F5F6F7'/><stop offset='.983' stop-color='#ECEDF0'/><stop offset='1' stop-color='#ECEDF0'/></linearGradient></defs><rect width='100%' height='100%' fill='url(#g1)'/></svg>" } =
  defineProps<{
    src?: string
    fallbackSrc?: string
  }>()

const intersectionWrapperRef = ref(undefined)
const targetWasEverVisible = ref(disableLazyLoading || false)

const { intersectionHappened, stopObserving } = useIntersectionObserver(
  intersectionWrapperRef
)

const computedSrc = computed(() =>
  src && targetWasEverVisible.value ? src : fallbackSrc
)

watchEffect(() => {
  if (intersectionHappened.value) {
    targetWasEverVisible.value = true
  }
})

watchEffect(() => {
  if (src && targetWasEverVisible.value) {
    stopObserving()
  }
})

onUnmounted(() => {
  stopObserving()
})
</script>
